/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, FlexContainer, Spacer, theme } from "@nordcloud/gnui";
import { CloudResourceReportsSortFields, SortOrder } from "~/generated/graphql";
import { SortSelector } from "~/components/SortSelector";
import { TABLE_LABELS } from "~/constants";
import { useQueryState } from "~/hooks";
import { ReportsQuery } from "~/views/resources_v2/types";
import { ReportsSearch } from "./ResourceReportsSearch";

const sortOptions = [
  {
    value: CloudResourceReportsSortFields.DateGenerated,
    label: "Date Generated",
  },
  {
    value: CloudResourceReportsSortFields.CreatedBy,
    label: TABLE_LABELS.createdBy,
  },
];

export function ResourceReportsListHeader() {
  const {
    queryState: { field, order },
    updateQueryState,
  } = useQueryState<ReportsQuery>();

  const handleSortDirection = (sortOrder: SortOrder) => {
    updateQueryState({
      order: sortOrder,
    });
  };

  const handleSortField = (sortField: CloudResourceReportsSortFields) => {
    updateQueryState({
      field: sortField,
    });
  };

  return (
    <Box boxStyle="lightGrey" spacing="spacing04">
      <FlexContainer justifyContent="space-between">
        <SortSelector<CloudResourceReportsSortFields>
          options={sortOptions}
          value={field ?? CloudResourceReportsSortFields.DateGenerated}
          direction={order ?? SortOrder.Asc}
          onSelect={handleSortField}
          onSortChange={handleSortDirection}
        />
        <Spacer width={theme.spacing.spacing04} />
        <ReportsSearch />
        <Spacer width={theme.spacing.spacing04} />
      </FlexContainer>
    </Box>
  );
}
